import styled from "styled-components";
import { Link } from "react-router-dom";

const FlexWrapper = styled.div(
  (props) => `
  width: ${props.width || "100%"};
  height: ${props.height || "auto"};
  min-width: ${props.minWidth || "auto"};
  display: ${props.display || "flex"};
  flex-direction: ${props.direction || "column"};
  justify-content: ${props.justifyContent || "flex-start"};
  align-items: ${props.alignItems || "flex-start"};
  margin: ${props.viewMargin || "0px"};
  padding: ${props.viewPadding || "0px"};
  flex-basis: ${props.flexBasis || "auto"};
  border: ${props.border || "none"};
  border-top: ${props.borderTop || "none"};
  border-right: ${props.borderRight || "none"};
  background: ${props.background || "transparent"};
  flex-wrap: ${props.flexWrap || "nowrap"};
  border-radius: ${props.borderRadius || "0"};
  position: ${props.position || "static"};
  box-shadow: ${props.boxShadow || "none"};
  cursor: ${props.cursor || "default"};
  overflow: ${props.overflow || "initial"};
  flex: ${props.flex || "auto"};
  z-index: ${props.zIndex || "auto"};
`
);

const StyledImage = styled.img(
  (props) => `
  width: ${props.width || "auto"};
  max-width: ${props.maxWidth || "initial"};
  height: ${props.height || "auto"};
  object-fit: ${props.objectFit || "cover"};
  flex: ${props.flex || "0"};
  margin: ${props.viewMargin || "0px"};

`
);

const StyledText = styled.p(
  (props) => `
  width: ${props.width || "auto"};
  font-size: ${props.fontSize || "16px"};
  color: ${props.color || "#515151"};
  line-height: ${props.lineHeight || "normal"};
  font-weight: ${props.fontWeight || "normal"};
  background-color: ${props.background || "transparent"};
  text-align: ${props.textAlign || "left"};
  padding: ${props.viewPadding || "0px"};
  text-decoration-line: ${props.textDecorationLine || "none"};
  font-family: inherit, sans-serif;
  text-transform: ${props.textTransform || "initial"};
  margin: ${props.viewMargin || "0px"};
  position: ${props.position || "static"};
  pointer-events: ${props.pointerEvents || "all"};
  opacity: ${props.opacity || "1"};
`
);
const StyledLink = styled(Link)(
  (props) => `
  font-size: ${props.fontSize || "14px"};
  padding: ${props.viewPadding || "0"};
  color: ${props.color || "#003E85"};
  transition: 0.2s ease-in;
  font-weight: ${props.fontWeight || 500};
  flex: ${props.flex || "0"};
  :hover {
    color: ${props.hoverColor || "#003E85"};
  }
`
);

const ContainerWrapper = styled.div`
  padding: 20px;
  @media (max-width: 768px) {
    padding: 10px;
  }
  @media (max-width: 425px) {
    padding: 6px;
  }
`;

const InvoiceValue = styled.p(
  (props) => `
  width: ${props.width || "100px"};
  font-size: ${props.fontSize || "18px"};
  color: ${props.color || "#515151"};
  line-height: ${props.lineHeight || "normal"};
  font-weight: ${props.fontWeight || "500"};
  position: ${props.position || "absolute"};
  right: 0;
`
);
const StyledAppTitle = styled.div`
  flex-basis: 200px;
  background: ${(props) => props.theme.primary};
  border-top-left-radius: 55px;
  text-align: center;
  padding: 14px 0;
  font-size: 18px;
`;

const StyledCard = styled.div(
  (props) => `
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
  margin: ${props.viewMargin || "0px"};
  padding: ${props.viewPadding || "0px"};
  background-color: ${props.background || "#ffffff"};
  border-radius:5px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  border-color: ${props.bordercolor || "rgba(0, 0, 0, 0.09)"};
  width: ${props.width || "100%"};
  height: ${props.height || "100%"};
  position: ${props.position || "static"};
  flex: ${props.flex || "auto"};
`
);

const StyledPageTitle = styled.h2(
  (props) => `
  margin: 10px 0;
  border-bottom:1px solid rgba(0, 0, 0, 0.06);
  font-size: ${props.fontSize || "16px"};
  padding: 10px 10px ;
  margin: ${props.viewMargin || "0"};
  background-color: ${props.background || "transparent"};
  color:#515151;
  font-weight: 500;
`
);
const SmallTitle = styled.p`
  font-size: 12px;
  padding: 5px 10px;
  color: #888888;
  margin-bottom: 10px;
`;

const TimeSpan = styled.p`
  font-size: 14px;
  margin: 25px 0 0 0;
  color: ${(props) => props.theme.primary};
`;
const Span = styled.span(
  (props) => `
  font-size:${props.fontSize || "14px"};
  padding: ${props.padding || "5px"};
  color:${props.color || props.theme.primary};
  font-weight: ${props.fontWeight || "normal"};
  `
);
const ModelWrapper = styled.div(
  (props) => `
  display: ${props.display || "none"}; 
  position: fixed; 
  z-index: 10; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4); 
  `
);
const Modal = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div(
  (props) => `
  background-color: #fefefe;
  margin: ${props.margin || "auto"};
  padding: 20px;
  border: 1px solid #888;
  border-radius: 4px;
  width: ${props.width || "100%"};
  `
);
const ModalContentView = styled.div(
  (props) => `
    width: ${props.width || "100%"};
    height: ${props.height || "auto"};
    min-width: ${props.minWidth || "auto"};
    display: flex;
    flex-direction: ${props.direction || "column"};
    justify-content: ${props.justifyContent || "flex-start"};
    align-items: ${props.alignItems || "flex-start"};
    margin: ${props.viewMargin || "0px"};
    padding: ${props.viewPadding || "0px"};
    flex-basis: ${props.flexBasis || "auto"};
    border: ${props.border || "none"};
    background: ${props.background || "transparent"};
    flex-wrap: ${props.flexWrap || "nowrap"};
    border-radius: ${props.borderRadius || "0"};
    position: ${props.position || "static"};
    box-shadow: ${props.boxShadow || "none"};
    cursor: ${props.cursor || "default"};
    overflow: ${props.overflow || "initial"};
    flex: ${props.flex || "auto"};
    `
);

const ModalHeader = styled.div`
  background-color: #ffffff;
  padding: 5px;
  text-align: center;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  color: #565656;
  font-weight: 600;
`;
const ModalClose = styled.div`
  background-color: #ffffff;
  padding: 3px;
  text-align: center;
  border: 1px solid #888;
  border-radius: 50%;
  display: flex;
  flex-direction: row-reverse;
  font-size: 12px;
  width: 25px;
  height: 25px;
`;
const Tab = styled.div`
  height: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin: 0 0 10px 0;
`;
const Unlist = styled.ul`
  list-style-type: none;
  margin: ${(props) => props.viewMargin || "0 0 0 0px"};
  font-size: ${(props) => props.fontSize || "12px"};
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${(props) => props.direction || "row;"};
`;
const List = styled.li`
  display: ${(props) => props.display || "inline-flex;"};
  padding: 2px;
  border-bottom: ${(props) => props.bordeBottom || "2px solid #fff"};
  border-bottom-color: ${(props) => props.bordeBottomColor || "hidden"};
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.viewMargin || "0 0 0 0px"};
  color: ${(props) => props.color || "#1a0dab"};
`;
const MachineID = styled.p`
  display: flex;
  font-size: 13px;
  margin: 0 0 10px 0;
`;
const MachineModel = styled.p`
  display: flex;
  font-size: 13px;
  margin: 0 0 10px 0;
`;
const ServiceType = styled.p`
  display: flex;
  font-size: 13px;
  margin: 0 0 10px 0;
`;
const Complaints = styled.p(
  (props) => `
  display:flex;
  font-size:13px;
  margin:0 0 5px 0;
  line-height: 40px;
  padding: 0 10px 0 0;
  font-weight:${props.fontWidth || "normal"};
  `
);
const SuggestedServiceJob = styled.p(
  (props) => `
  display:flex;
  font-size:13px;
  margin:0 0 5px 0;
  line-height: 40px;
  padding: 0 10px 0 0;
  font-weight:${props.fontWidth || "normal"};
  `
);
const SelectArea = styled.div(
  (props) => `
  width: ${props.width || "100%"};
  padding: ${props.viewPadding || "0px"};
  flex:${props.flex || 1};
  position:${props.position || "static"};
  z-index:${props.zIndex || "auto"};
  `
);
const SearchResult = styled.div(
  (props) => `
  width: ${props.width || "70%"};
  min-height:59px;
  padding: ${props.viewPadding || "0px"};
  `
);
const SearchResultIcon = styled.div(
  (props) => `
  width: ${props.width || "30%"};
  padding: ${props.viewPadding || "0px"};
  `
);
const Timeline = styled.div(
  (props) => `
  position: relative;
  max-width: 1200px;
  margin: ${props.viewMargin || "35px auto 0 auto"};
  @media(max-width:768px) {
    :after {
      background-color: #c7c7c7 !important;
    }
  }
  :after{
    content: '';
    position: absolute;
    width: 6px;
    background-color: #e6e4e4;
    top: -35px;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
  }
  `
);
const TimelineContainer = styled.div(
  (props) => `
  padding: 10px 40px;
  position: relative;
  width: ${props.width || "50%"};
  left: ${props.left || "0"};
  right: ${props.right || "0"};
  @media(max-width:768px){
    padding: 8px;
    width: 100%;
    z-index:1;
    :after {
      display: none
    }
  }
  :after {
    content: '';
    position: absolute;
    width: 30px;
    right: ${props.aferRight || "-15px"};
    left: ${props.aferLeft || "initial"};
    background-color: ${props.backgroundColor || props.theme.primary};
    border: 4px soid #FF9F55;
    top: 30px;
    border-radius: 50%;
    z-index: 1;
    padding:15px 0;
    color:#ffffff;
    text-align:center;
    font-size:12px;
  }
  `
);
const TimelinePlaceLeft = styled.div(
  (props) => `
  // :before {
  //   content: "";
  //   height: 0;
  //   position: absolute;
  //   top: 38px;
  //   width: 0;
  //   z-index: 1;
  //   right: 30px;
  //   border: medium solid white;
  //   border-width: 10px 0 10px 10px;
  //   border-color: transparent transparent transparent white;
  // }
  :after {
    left: -16px;
    border-color:transparent ${
      props.backgroundColor || props.theme.primary
    } transparent transparent ;
  }
  :before {
    border-color:transparent transparent transparent ${
      props.backgroundColor || props.theme.primary
    };
  }
  `
);
const TimelinePlaceRight = styled.div(
  (props) => `
  left: ${props.left || "50%"};
  :before {
    content: " ";
    height: 0;
    position: absolute;
    top: 38px;
    width: 0;
    z-index: 1;
    left: 30px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent; 
  }
  
  `
);
const TimelineContent = styled.div(
  (props) => `
  padding: 20px 30px;
  background-color: ${props.background || "#fff"};
  position: relative;
  border-radius: 6px;
  font-size:12px;
  box-shadow: 3px 2px 7px 2px rgba(201,201,201,1);
  `
);
const DummyLabel = styled.label(
  (props) => `
  background-color: #fff;
  font-size:13px;
  display:inline-block;
  z-index: 1;
  position: absolute;
  top:${props.top || "7px"};
  left:${props.left || "18px"};
  background: #ffffff;
  font-weight: 500;
  color:#565656;
  `
);
const DatepickerArea = styled.div(
  (props) => `
  width: ${props.width || "100%"};
  padding: ${props.viewPadding || "0px"};
  flex:${props.flex || 1};
  position: relative;
  `
);
const Designation = styled.p(
  (props) => `
  font-size: ${props.fontSize || "12px"};
  width: ${props.width || "100%"};
  padding: ${props.viewPadding || "0px"};
  margin: ${props.viewMargin || "0px"};
  `
);
const DateMonth = styled.p`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-radius: 5px;
  padding: 10px;
  text-align: center;

  border-radius: 5px;
`;

const LeaveTitle = styled.h4(
  (props) => `
  font-size: ${props.fontSize || "12px"};
  padding: 5px;
  border-bottom: 1px solid #f0f0f0;
  `
);
const Name = styled.h4(
  (props) => `
  font-size: ${props.fontSize || "13px"};
  margin: ${props.viewMargin || "0px 0px 5px 0px;"};
  color:#4b4b4b;
  `
);
const Duration = styled.div(
  (props) => `
  width: ${props.width || "100%"};
  height: ${props.height || "100%"};
  min-width: ${props.minWidth || "auto"};
  display: flex;
  flex-direction: ${props.direction || "column"};
  justify-content: ${props.justifyContent || "center"};
  align-items: ${props.alignItems || "center"};
  margin: ${props.viewMargin || "0px"};
  padding: ${props.viewPadding || "3px 5px"};
  flex-basis: ${props.flexBasis || "auto"};
  border: ${props.border || "none"};
  border-top: ${props.borderTop || "none"};
  background: ${props.background || "transparent"};
  flex-wrap: ${props.flexWrap || "nowrap"};
  border-radius: ${props.borderRadius || "0"};
  position: ${props.position || "static"};
  box-shadow: ${props.boxShadow || "none"};
  cursor: ${props.cursor || "default"};
  overflow: ${props.overflow || "initial"};
  flex: ${props.flex || "auto"};
  text-align:center;
  font-size: ${props.fontSize || "12px"};
  border-radius: 5px;
  `
);
const Hr = styled.hr`
  border: 1px solid #f0f0f0;
  border-radius: 5px;
`;

const WorkOrder = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  position: absolute;
  right: 5px;
  background: ${(props) => props.theme.primary};
  color: #fff;
  margin-top: 5px;
  font-size: 13px;
  padding: 3px;
`;

const FileUpload = styled.div`
  background: ${(props) => props.theme.primary};
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 4px;
  color: #000;
  font-size: 14px;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  padding: 10px 20px;
  width: auto;
  height: 40px;
`;

const Upload = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  width: 148px;
  height: 46px;
  cursor: pointer;
`;

const TypeList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const TypeListItom = styled.div`
  background-color: #f1f1f1;
  margin: 10px;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  font-size: 13px;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.09);
  border: 1px solid rgba(0, 0, 0, 0.02);
  color: #515151;
`;
const LoginBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-image: url(https://www.cnhindustrial.com/PublishingImages/our_brands/case_construction_equipment_top.jpg);
  height: 100vh;
  background-size: cover;
  /*background-color: #f2f2f2;*/
`;

const Login = styled.div`
  background-color: #fff;
  color: #000000;
  min-width: 470px;
  max-width: 470px;
  height: auto;
  border-radius: 5px;
  padding: 25px 10px;
  box-shadow: 0px 7px 8px -5px rgba(219, 219, 219, 1);
  margin-right: 50px;
`;

export {
  StyledText,
  FlexWrapper,
  StyledImage,
  StyledLink,
  StyledAppTitle,
  StyledCard,
  StyledPageTitle,
  SmallTitle,
  TimeSpan,
  Span,
  ModelWrapper,
  ModalContent,
  ModalHeader,
  ModalContentView,
  ModalClose,
  Tab,
  Unlist,
  List,
  MachineID,
  MachineModel,
  ServiceType,
  SuggestedServiceJob,
  SelectArea,
  Complaints,
  SearchResult,
  SearchResultIcon,
  Timeline,
  TimelineContainer,
  TimelinePlaceLeft,
  TimelinePlaceRight,
  TimelineContent,
  DummyLabel,
  DatepickerArea,
  Modal,
  Designation,
  DateMonth,
  LeaveTitle,
  Name,
  Duration,
  Hr,
  WorkOrder,
  FileUpload,
  Upload,
  InvoiceValue,
  TypeList,
  TypeListItom,
  ContainerWrapper,
  Login,
  LoginBox,
};
